/*
  bfroz-cart.js : tiroir panier (port de CartContext.tsx + CartDrawer.tsx) branché sur le panier Shopify.

  Requêtes : GET  {cartUrl}.js            au chargement (synchronise le badge)
             POST {cartAddUrl}.js         { items:[{id, quantity}], sections:'cart-drawer' }
             POST {cartChangeUrl}.js      { id:<line key>, quantity, sections:'cart-drawer' }
             POST {cartClearUrl}.js       { sections:'cart-drawer' }
             GET  {rootUrl}?sections=cart-drawer   (re-rendu à la demande)
  Après chaque action, le HTML de la section « cart-drawer » renvoyé par Shopify remplace le
  contenu de [data-cart-panel] : le markup n'existe qu'en Liquid (sections/cart-drawer.liquid).

  API publique : window.BFROZ.cart
    add({ id: variantId, quantity })  → ajoute, rafraîchit, met à jour le badge, OUVRE le tiroir
    add([{ id, quantity }, ...])      → plusieurs lignes d'un coup
    change(lineKey, quantity)         → quantité d'une ligne (0 = retirer)
    clear()                           → vide le panier
    open() / close() / toggle()
    refresh()                         → re-rend le tiroir + badge depuis le serveur
    money(cents)                      → « 39.99$ » (format du site)
  Attributs délégués (document) :
    [data-add-to-cart="<variantId>"] (+ data-quantity, ou un [data-qty-input] dans le [data-product] parent)
    [data-cart-open]  (géré par bfroz-header.js, repli ici via l'événement bfroz:cart:open)
  Événements : bfroz:cart:updated (detail = { itemCount }), bfroz:cart:opened, bfroz:cart:closed
  Infolettre du pied de page : envoi sans rechargement + succès affiché 4 s (comme Footer.tsx).
*/
(function () {
  'use strict';

  var BFROZ = (window.BFROZ = window.BFROZ || {});
  var html = document.documentElement;

  // Le filtre Liquid `t` renvoie du HTML déjà échappé (« t&#39;es »), et `json` le transporte tel quel
  // jusqu'au JS. Tout texte lu d'un JSON et posé en textContent doit donc être décodé d'abord.
  var decodeArea = null;
  function decodeEntities(s) {
    if (s.indexOf('&') === -1) return s;
    if (!decodeArea) decodeArea = document.createElement('textarea');
    decodeArea.innerHTML = s;
    return decodeArea.value;
  }
  function decodeDeep(v) {
    if (typeof v === 'string') return decodeEntities(v);
    if (Object.prototype.toString.call(v) === '[object Array]') {
      for (var i = 0; i < v.length; i++) v[i] = decodeDeep(v[i]);
      return v;
    }
    if (v && typeof v === 'object') {
      for (var k in v) if (Object.prototype.hasOwnProperty.call(v, k)) v[k] = decodeDeep(v[k]);
      return v;
    }
    return v;
  }
  BFROZ.decodeEntities = decodeEntities;
  BFROZ.decodeDeep = decodeDeep;

  function readJson(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try {
      return decodeDeep(JSON.parse(el.textContent));
    } catch (e) {
      return fallback;
    }
  }
  var cfg = readJson('bfroz-config', {});
  var labels = cfg.labels || {};
  BFROZ.flavors = readJson('bfroz-flavors', {});
  BFROZ.config = cfg;

  var root = document.querySelector('[data-cart-drawer]');
  var backdrop = root ? root.querySelector('[data-cart-backdrop]') : null;
  var panel = root ? root.querySelector('[data-cart-panel]') : null;
  var isOpen = false;
  var busy = false;

  function money(cents) {
    return (Number(cents || 0) / 100).toFixed(2) + '$';
  }

  function setCount(n) {
    n = Number(n) || 0;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(n);
      badges[i].classList.toggle('hidden', n <= 0);
    }
    if (root) root.setAttribute('data-item-count', String(n));
    document.dispatchEvent(new CustomEvent('bfroz:cart:updated', { detail: { itemCount: n } }));
  }

  // ---------- ouverture / fermeture ----------
  function open() {
    if (!panel || isOpen) return;
    isOpen = true;
    backdrop.classList.remove('opacity-0', 'pointer-events-none');
    backdrop.classList.add('opacity-100');
    panel.classList.remove('translate-x-full');
    panel.classList.add('translate-x-0');
    panel.setAttribute('aria-hidden', 'false');
    html.classList.add('bfroz-scroll-lock');
    var closeBtn = panel.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('bfroz:cart:opened'));
  }
  function close() {
    if (!panel || !isOpen) return;
    isOpen = false;
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    backdrop.classList.remove('opacity-100');
    panel.classList.add('translate-x-full');
    panel.classList.remove('translate-x-0');
    panel.setAttribute('aria-hidden', 'true');
    html.classList.remove('bfroz-scroll-lock');
    document.dispatchEvent(new CustomEvent('bfroz:cart:closed'));
  }
  function toggle() {
    if (isOpen) close();
    else open();
  }

  // ---------- rendu ----------
  function applySectionHtml(sectionHtml) {
    if (!panel || !sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    var freshPanel = fresh.querySelector('[data-cart-panel]');
    if (freshPanel) panel.innerHTML = freshPanel.innerHTML;
    setCount(fresh.getAttribute('data-item-count'));
  }
  function showError(message) {
    if (!panel) return;
    var el = panel.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message || labels.errorUpdate || '';
    el.classList.remove('hidden');
  }
  function setBusy(v) {
    busy = v;
    if (panel) panel.setAttribute('aria-busy', v ? 'true' : 'false');
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: 'cart-drawer' }))
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function refresh() {
    var url = (cfg.rootUrl || '/') + '?sections=cart-drawer';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        applySectionHtml(json && json['cart-drawer']);
      });
  }

  function syncCount() {
    return fetch((cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var current = root ? Number(root.getAttribute('data-item-count')) : -1;
        setCount(cart.item_count);
        // le HTML servi est périmé (retour arrière, cache) : on re-rend
        if (current !== -1 && current !== Number(cart.item_count)) return refresh();
        return cart;
      })
      .catch(function () {});
  }

  // ---------- actions ----------
  function add(input) {
    var items = Array.isArray(input) ? input : [input];
    items = items.map(function (it) {
      var line = { id: it.id, quantity: Math.max(1, parseInt(it.quantity, 10) || 1) };
      if (it.properties) line.properties = it.properties;
      return line;
    });
    setBusy(true);
    return post(cfg.cartAddUrl || '/cart/add', { items: items })
      .then(function (json) {
        applySectionHtml(json.sections && json.sections['cart-drawer']);
        open();
        return json;
      })
      .catch(function (err) {
        open();
        showError((err && err.description) || labels.errorUpdate);
        throw err;
      })
      .finally(function () {
        setBusy(false);
      });
  }
  function change(key, quantity) {
    setBusy(true);
    return post(cfg.cartChangeUrl || '/cart/change', { id: key, quantity: Math.max(0, parseInt(quantity, 10) || 0) })
      .then(function (json) {
        applySectionHtml(json.sections && json.sections['cart-drawer']);
        return json;
      })
      .catch(function (err) {
        showError((err && err.description) || labels.errorUpdate);
        throw err;
      })
      .finally(function () {
        setBusy(false);
      });
  }
  function clear() {
    setBusy(true);
    return post(cfg.cartClearUrl || '/cart/clear', {})
      .then(function (json) {
        applySectionHtml(json.sections && json.sections['cart-drawer']);
        return json;
      })
      .catch(function (err) {
        showError((err && err.description) || labels.errorUpdate);
        throw err;
      })
      .finally(function () {
        setBusy(false);
      });
  }

  // ---------- événements du tiroir ----------
  if (root) {
    backdrop.addEventListener('click', close);
    root.addEventListener('click', function (e) {
      var t = e.target;
      var closeBtn = t.closest('[data-cart-close]');
      if (closeBtn) {
        if (closeBtn.tagName !== 'A') e.preventDefault();
        close();
        return;
      }
      var changeBtn = t.closest('[data-cart-change]');
      if (changeBtn) {
        e.preventDefault();
        if (busy) return;
        change(changeBtn.getAttribute('data-key'), changeBtn.getAttribute('data-quantity'));
        return;
      }
      var clearBtn = t.closest('[data-cart-clear]');
      if (clearBtn) {
        e.preventDefault();
        if (busy) return;
        clear();
        return;
      }
      var checkout = t.closest('[data-cart-checkout]');
      if (checkout) {
        var label = checkout.querySelector('[data-cart-checkout-label]');
        var loading = checkout.querySelector('[data-cart-checkout-loading]');
        if (label) label.classList.add('hidden');
        if (loading) {
          loading.classList.remove('hidden');
          loading.classList.add('inline-flex');
        }
        checkout.classList.add('opacity-70', 'pointer-events-none');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }
  document.addEventListener('bfroz:cart:open', open);

  // boutons [data-cart-change] hors tiroir (page /cart)
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (root && root.contains(t)) return;
    var changeBtn = t.closest('[data-cart-change]');
    if (changeBtn) {
      e.preventDefault();
      change(changeBtn.getAttribute('data-key'), changeBtn.getAttribute('data-quantity')).then(function () {
        window.location.reload();
      });
      return;
    }
    var addBtn = t.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var qty = addBtn.getAttribute('data-quantity');
      if (!qty) {
        var scope = addBtn.closest('[data-product]') || document;
        var input = scope.querySelector('[data-qty-input]');
        if (input) qty = input.value;
      }
      add({ id: addBtn.getAttribute('data-add-to-cart'), quantity: qty || 1 });
    }
  });

  // ---------- infolettre (pied de page) ----------
  (function newsletter() {
    var form = document.querySelector('[data-newsletter-form]');
    if (!form) return;
    var fields = form.querySelector('[data-newsletter-fields]');
    var success = form.querySelector('[data-newsletter-success]');
    var RESET_MS = 4000;

    function showSuccess() {
      if (success) success.classList.remove('hidden');
      if (fields) fields.classList.add('hidden');
      var email = form.querySelector('input[type="email"]');
      if (email) email.value = '';
      setTimeout(function () {
        if (success) success.classList.add('hidden');
        if (fields) fields.classList.remove('hidden');
      }, RESET_MS);
    }

    // Rechargement après envoi natif (form.posted_successfully?) : même délai de 4 s
    if (success && !success.classList.contains('hidden')) {
      setTimeout(function () {
        success.classList.add('hidden');
        if (fields) fields.classList.remove('hidden');
      }, RESET_MS);
    }

    var sending = false;
    form.addEventListener('submit', function (e) {
      if (sending || !window.fetch) return;
      e.preventDefault();
      sending = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow', credentials: 'same-origin' })
        .then(function (res) {
          var url = res.url || '';
          if (url.indexOf('customer_posted=true') !== -1) {
            showSuccess();
            return;
          }
          // captcha ou erreur : on laisse Shopify rendre la page (form.errors / challenge)
          sending = false;
          form.submit();
        })
        .catch(function () {
          sending = false;
          form.submit();
        })
        .then(function () {
          sending = false;
        });
    });
  })();

  BFROZ.cart = {
    add: add,
    change: change,
    clear: clear,
    open: open,
    close: close,
    toggle: toggle,
    refresh: refresh,
    money: money,
    isOpen: function () {
      return isOpen;
    }
  };

  syncCount();
})();
